/*
  JPT - 06/28/2022:  We are pulling in an external script for which we have no type
  definitions. There may not be a way to satisfy 'undefined' IDE errors here.
*/
import React, { useEffect, useState } from 'react';
import { showLiveIndicator } from '@services';
import { GlobalContext } from '../GlobalContext';
import LiveIndicator from '../LiveIndicator';

type VideoPlayerProps = {
  playbackId: string
  playerName?: string
  autoPlay?: boolean
  video?: any
}

type BoxcastContext = {
  boxcastContext: Object
}

function VideoPlayer({
  playbackId, playerName, autoPlay, video,
}: VideoPlayerProps) {
  const globalContext = React.useContext(GlobalContext);
  const [boxcastContext, setBoxcastContext] = useState<BoxcastContext>();
  const loadBoxcastScripts = (callback: any) => {
    const existingScript = document.querySelector('#boxcast');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://js.boxcast.com/v3.min.js';
      script.id = 'boxcast';
      document.head.appendChild(script);
      script.onload = () => {
        if (callback) callback();
      };
    }
    if (existingScript && callback) callback();
  };

  const loadVideo = async () => {
    const context = boxcast(`#${playerName}`);
    setBoxcastContext(context);
    const checkAutoPlay = (player: any) => {
      if (autoPlay) {
        player.play();
      }
    };
    await context.loadChannel(playbackId, {
      showTitle: false,
      showDescription: false,
      showHighlights: false,
      showRelated: false,
      showChat: false,
      playInline: true,
      onLoadPlayer(player: any) {
        checkAutoPlay(player);
      },
    });
  };
  const unloadBoxcast = () => {
    if (!boxcastContext) return;
    if (typeof boxcastContext?.unload === 'function') {
      boxcastContext.unload();
    }
  };
  // run once on load
  useEffect(() => {
    if (!boxcastContext) loadBoxcastScripts(loadVideo);
    return unloadBoxcast;
  }, []);
  return (
    <div className="relative chd-video-container">
      <div id={playerName} />
      {showLiveIndicator(globalContext?.liveItems, video) && (
        <LiveIndicator />
      )}
    </div>
  );
}
VideoPlayer.defaultProps = {
  playerName: 'default-player',
  autoPlay: false,
  video: null,
};
export default VideoPlayer;
